import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { useDataRequest } from '@ai4/data-request';
import { Role } from '../types';

interface Props {
	show: boolean;
	selected: any;
	onCloseAddPopup: () => void;
}

function AddPermissionPopup(props: Props) {
	const { selected, onCloseAddPopup } = props;
	const { permission } = selected;
	const [roles, setRoles] = useState<Role[]>([]);
	const [show, setShow] = useState(props.show);
	const { useRestRequest } = useDataRequest();
	const [req] = useRestRequest({
		path: 'api/{ver}/roles',
		method: 'GET',
		jwt: true,
	});
	const [reqAdd] = useRestRequest({
		path: 'api/{ver}/roles/{id}/permissions/{code}',
		method: 'POST',
		jwt: true,
	});

	useEffect(() => {
		const boot = async () => {
			const roles = await req();
			setRoles(roles as Role[]);
		};
		boot();
	}, []);

	const addPermission = async (role: Role) => {
		try {
			await reqAdd({
				path: `api/{ver}/roles/${role.id}/permissions/${permission.code}`,
			});
			alert(`Aggiunto "${role.name}" a ${permission.name}`);
		} catch (e) {
			alert('Errore nel salvataggio');
		} finally {
			onCloseAddPopup();
		}
	};

	const handleClose = () => {
		setShow(false);
	};

	const handleClosed = () => {
		onCloseAddPopup();
	};

	if (roles.length === 0) return null;
	return (
		<div>
			<Modal show={show} onHide={handleClose} onExited={handleClosed} size='xl'>
				<Modal.Header closeButton>
					<Modal.Title>Aggiungi permesso</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<h5>Seleziona il ruolo da aggiungere</h5>
					<ListGroup>
						{roles.map((role, k) => {
							return (
								<ListGroup.Item key={k} action onClick={() => addPermission(role)}>
									{role.name}
								</ListGroup.Item>
							);
						})}
					</ListGroup>
				</Modal.Body>

				<Modal.Footer>
					<Button variant='secondary' onClick={handleClose}>
						Annulla
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}

export default AddPermissionPopup;
